<template>
  <img
    :src="computedSrc"
    :alt="dataAlt"
  >
</template>

<script>

export default {
  name: 'SwapBigAndSmallImage',
  props: {
    dataAlt: {
      type: String,
      default: ''
    },
    dataSrc: {
      type: String,
      default: ''
    },
    dataSmallSrc: {
      type: String,
      default: ''
    },
  },
  computed: {
    computedSrc() {
      if (this.$viewportWidth < 768) {
        return this.dataSmallSrc ? this.dataSmallSrc : this.dataSrc;
      } else {
        return this.dataSrc;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
